import { Component, computed, input, output, signal } from '@angular/core';
import { FormField as AngularFormField, type FieldTree } from '@angular/forms/signals';

@Component({
  imports: [AngularFormField],
  selector: 'app-form-field',
  styleUrl: './form-field.css',
  templateUrl: './form-field.html',
})
export class FormField {
  public readonly fieldId = input.required<string>();
  public readonly formField = input.required<FieldTree<string, string>>();
  public readonly invalidPlaceholder = input('');
  public readonly isDirty = input(false);
  public readonly isRequired = input(false);
  public readonly isValid = input(true);
  public readonly label = input('');
  public readonly placeholder = input('');
  public readonly type = input<'email' | 'number' | 'password' | 'tel' | 'text' | 'textarea'>(
    'text',
  );
  public readonly valueChanged = output();

  protected readonly errorId = computed(() => `${this.fieldId()}-error`);
  protected readonly isInvalid = computed(() => this.isDirty() && !this.isValid());
  protected readonly inputClass = computed(() => {
    if (this.isInvalid()) {
      return 'block min-w-0 w-full grow bg-transparent py-1.5 pr-3 pl-1 text-base text-red-500 placeholder:text-red-300 focus:outline-none sm:text-sm/6';
    } else {
      return 'block min-w-0 w-rull grow bg-transparent py-1.5 pr-3 pl-1 text-base placeholder:text-gray-400 focus:outline-none sm:text-sm/6';
    }
  });
  protected readonly inputContainerClass = computed(() => {
    if (this.isInvalid()) {
      return `flex items-center rounded-md bg-white dark:bg-gray-900/50 pl-3 outline-1 -outline-offset-1 outline-red-200 dark:outline-red-400 focus-within:outline-2 focus-within:-outline-offset-2 ${this.label() ? 'sm:max-w-md' : ''}`;
    } else {
      return `flex items-center rounded-md bg-white dark:bg-gray-900/50 pl-3 outline-1 -outline-offset-1 outline-gray-300 dark:outline-gray-900 focus-within:outline-2 focus-within:-outline-offset-2 ${this.label() ? 'sm:max-w-md' : ''}`;
    }
  });
  protected readonly labelClass = computed(() => {
    const _nowrap = this.isRequired() ? ' whitespace-nowrap' : '';
    if (this.isInvalid()) {
      return `flex items-baseline gap-0.5${_nowrap} text-sm/6 font-medium text-red-500 dark:text-red-400 sm:pt-1.5`;
    } else {
      return `flex items-baseline gap-0.5${_nowrap} text-sm/6 font-medium sm:pt-1.5`;
    }
  });
  protected readonly showPassword = signal(false);

  protected togglePasswordVisibility(): void {
    this.showPassword.set(!this.showPassword());
  }
}
